import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as h, unref as e, renderSlot as p, createElementVNode as V, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, m = { key: 1 }, f = { key: 2 }, k = { key: 3 }, A = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconTextT"
}, _ = /* @__PURE__ */ d({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const r = l, { bind: s, weight: n } = u(r);
    return (H, t) => (a(), o("svg", h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(H.$slots, "default"),
      e(n) === "bold" ? (a(), o("g", g, t[0] || (t[0] = [
        V("path", { d: "M212,56V88a12,12,0,0,1-24,0V68H140V188h20a12,12,0,0,1,0,24H96a12,12,0,0,1,0-24h20V68H68V88a12,12,0,0,1-24,0V56A12,12,0,0,1,56,44H200A12,12,0,0,1,212,56Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (a(), o("g", m, t[1] || (t[1] = [
        V("path", {
          d: "M200,56V184a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V56Z",
          opacity: "0.2"
        }, null, -1),
        V("path", { d: "M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z" }, null, -1)
      ]))) : e(n) === "fill" ? (a(), o("g", f, t[2] || (t[2] = [
        V("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,96a8,8,0,0,1-16,0V88H136v88h12a8,8,0,0,1,0,16H108a8,8,0,0,1,0-16h12V88H88v8a8,8,0,0,1-16,0V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z" }, null, -1)
      ]))) : e(n) === "light" ? (a(), o("g", k, t[3] || (t[3] = [
        V("path", { d: "M206,56V88a6,6,0,0,1-12,0V62H134V194h26a6,6,0,0,1,0,12H96a6,6,0,0,1,0-12h26V62H62V88a6,6,0,0,1-12,0V56a6,6,0,0,1,6-6H200A6,6,0,0,1,206,56Z" }, null, -1)
      ]))) : e(n) === "regular" ? (a(), o("g", A, t[4] || (t[4] = [
        V("path", { d: "M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z" }, null, -1)
      ]))) : e(n) === "thin" ? (a(), o("g", M, t[5] || (t[5] = [
        V("path", { d: "M204,56V88a4,4,0,0,1-8,0V60H132V196h28a4,4,0,0,1,0,8H96a4,4,0,0,1,0-8h28V60H60V88a4,4,0,0,1-8,0V56a4,4,0,0,1,4-4H200A4,4,0,0,1,204,56Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
